<template>
    <div>
        <NuxtLayout>
            <template #body_page>
                <SectionHero class="bg-hero pt-100 pb-100">
                    <template #title>
                        This is travel <br class="sp-none"> reimagined
                    </template>
                    <template #sub-title>
                        Join our network of Local Designers
                    </template>
                    <template #button>
                        <button class="button button-blue" type="button" @click="goto">
                            Become a Local Designer
                        </button>
                    </template>
                </SectionHero>
                <div class="requirement">
                    <div class="container flex mb-flex-wrap">
                        <div class="wp-100 maxw-350 mr-100 mb-mr-0">
                            <h2 class="black fw-900 fs-36 lh-36 mb-30 mb-fs-28 mb-lh-28">How to Become a Local Designer</h2>
                            <div class="black fs-16 lh-24">
                                To become a Designer Journeys Local Designer, applicants must complete a rigorous selection

                                process to ensure they are reliable, vetted, trustworthy and deliver quality travel experiences to our Travellers and Travel Agents every time.
                                <br><br>

                                Only when they have passed this process, provided strong evidence of quality traveller feedback and provided necessary accreditations do they become a Designer Journeys Local Designer.
                            </div>
                        </div>
                        <div class="flex flex-wrap mt-70 mb-mt-30" style="gap: 30px 50px">
                            <div class="w-342 mb-wp-100 mb-flex mb-flex-wrap">
                                <div class="flex items-center">
                                    <img class="flex-shrink-0" src="https://s3-cdn.designerjourneys.com/static/images/user/local-designer/icon-feedback.svg" alt="verified" />
                                    <h3 class="fw-700 fs-16 lh-16 ml-20">Verified Positive Feedback</h3>
                                </div>
                                <div class="fs-16 lh-24 black mt-10 ml-42">
                                    As part of the process to becoming a Local Designer, you must provide evidence of verified positive online or offline third party feedback.
                                </div>
                            </div>
                            <div class="w-342 mb-wp-100 mb-flex mb-flex-wrap">
                                <div class="flex items-center">
                                    <img class="flex-shrink-0" src="https://s3-cdn.designerjourneys.com/static/images/user/local-designer/accept.svg" alt="accept"/>
                                    <h3 class="fw-700 fs-16 lh-16 ml-20">Accept Our Terms</h3>
                                </div>
                                <div class="fs-16 lh-24 black mt-10 ml-42">
                                    In order to become a Local Designer, you must accept of our marketplace <router-link to='/terms-of-use'><small class='black underline fs-16'>Terms of Use</small></router-link>.
                                </div>
                            </div>
                            <div class="w-342 mb-wp-100 mb-flex mb-flex-wrap">
                                <div class="flex items-center">
                                    <img class="flex-shrink-0" src="https://s3-cdn.designerjourneys.com/static/images/user/local-designer/secure.svg" alt="insurance" />
                                    <h3 class="fw-700 fs-16 lh-16 ml-20">Insurance</h3>
                                </div>
                                <div class="fs-16 lh-24 black mt-10 ml-42">
                                    You must provide information about all local insurance coverage you provide Travellers and Travel Agents.
                                </div>
                            </div>
                            <div class="w-342 mb-wp-100 mb-flex mb-flex-wrap">
                                <div class="flex items-center">
                                    <img class="flex-shrink-0" src="https://s3-cdn.designerjourneys.com/static/images/user/local-designer/industry.svg" alt="accredit and license" />
                                    <h3 class="fw-700 fs-16 lh-16 ml-20">Accreditations and Licences</h3>
                                </div>
                                <div class="fs-16 lh-24 black mt-10 ml-42">
                                    You must provide information about any local accreditations and licences required to become a Local Designer.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="benefit-wrapper pt-100 mb-pt-60 mb-pb-60">
                    <div class="container">
                        <div class="flex mb-flex-wrap mb-flex-column-reverse mb-mb-60">
                            <div class="wp-100 maxw-430 mr-100 mb-mt-100 mb-mr-0">
                                <h2 class="black fs-36 lh-36 fw-900 mb-30 mb-fs-28 mb-lh-28">
                                    Who Is This For?
                                </h2>
                                <div class="black fs-16 lh-24">
                                    Designer Journeys’ global network of Local Designers are hand-selected, deeply knowledgeable local travel experts that deliver unique experiences for travellers every day.
                                    <br> <br>
                                    Local Designer is the collective name for our network of approved and trusted experts made up of in-destination inbound travel agents, tour operators, destination management companies, guiding companies and accommodation providers that build custom travel experiences and curated travel packages with their local knowledge and insight of their country.
                                    <br> <br>
                                    The key is that Local Designers are local, flexible, very responsive and competitive, and experts in leveraging their local knowledge to turn a client’s inspiration into the perfect trip.
                                </div>
                            </div>
                            <div class="wp-100 relative mb-maxw-400 mb-m-auto custom-img">
                                <div class="mb-w-280">
                                    <img
                                        class="br-16 mb-w-280"
                                        src="https://s3-cdn.designerjourneys.com/static/images/user/local-designer/bannerLarge.jpg"
                                        alt="banner large"
                                    />
                                    <img
                                        class="br-16 absolute nright-35 mb-right-30 top-220 mb-w-150 mb-top-140"
                                        src="https://s3-cdn.designerjourneys.com/static/images/user/local-designer/bannerSmall.jpg"
                                        alt="banner small"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="flex mb-flex-wrap">
                            <div class="relative mr-100 mb-mr-0">
                                <div><img
                                    class="br-16 mb-w-335"
                                    src="https://s3-cdn.designerjourneys.com/static/images/user/local-designer/bannerSecond.jpg"
                                    alt="banner second"
                                /></div>
                            </div>
                            <div class="wp-100 mt-50">
                                <h2 class="black fs-36 lh-36 fw-900 mb-30 mb-fs-28 mb-lh-28">
                                    Why Partner With Us
                                </h2>
                                <div class="black fs-16 lh-24">
                                    Once approved as a trusted Local Designer, you’ll enjoy the benefits of industry-leading Trip Plan technology.
                                    <br><br>
                                    As a Local Designer, you'll gain access to a powerful global marketplace where you will be connected directly with Travellers and Travel Agents from the world’s most lucrative travel markets. <br> With Designer Journeys, you'll be able to build your business and create a new revenue stream as you build your Designer Journeys profile.
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="benefit">
                    <div class="container flex mb-flex-wrap">
                        <div class="wp-100 maxw-350 mr-100 mb-mr-0">
                            <h2 class="black fw-900 fs-36 lh-36 mb-30 mb-fs-28 mb-lh-28">Benefits</h2>
                            <div class="black fs-16 lh-24">
                                At Designer Journeys, we place our network of trusted Local Designers at the heart of everything we do.
                                <br><br>

                                As one of our Local Designers, you will be supported at every step of the process. Here are some of the key benefits.
                            </div>
                        </div>
                        <div class="flex flex-wrap mt-70 mb-mt-30 benefit-item" style="gap: 30px 50px">
                            <div class="w-200 mb-wp-100 mb-flex items-center">
                                <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/market.svg" class='h-35' alt="market icon" />
                                <div class="fs-16 lh-24 black mt-10 mb-ml-20">
                                    B2B and B2C Market Access
                                </div>
                            </div>
                            <div class="w-200 mb-wp-100 mb-flex items-center">
                                <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/award.svg" class='h-35'  alt="award icon" />
                                <div class="fs-16 lh-24 black mt-10 mb-ml-20">
                                    Local Designer Awards Scheme
                                </div>
                            </div>
                            <div class="w-200 mb-wp-100 mb-flex items-center">
                                <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/hand.svg" class='h-35'  alt="hand icon" />
                                <div class="fs-16 lh-24 black mt-10 mb-ml-20">Easy-to-Use Platform for Lead Management</div>
                            </div>
                            <div class="w-200 mb-wp-100 mb-flex items-center">
                                <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/training.svg" class='h-35'  alt="training icon" />
                                <div class="fs-16 lh-24 black mt-10 mb-ml-20">Full Training and Sales Support from Network Team</div>
                            </div>
                            <div class="w-200 mb-wp-100 mb-flex items-center">
                                <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/digital.svg" class='h-35' alt="digital icon" />
                                <div class="fs-16 lh-24 black mt-10 mb-ml-20">
                                    Digital Itineraries Built by Content Team
                                </div>
                            </div>
                            <div class="w-200 mb-wp-100 mb-flex items-center">
                                <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/flexible.svg" class='h-35' alt="flexible icon" />
                                <div class="fs-16 lh-24 black mt-10 mb-ml-20">
                                    Flexible Cancellation Policies and Access to Payment Solutions
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SectionQuestion :faqs="faqs" :expandAll="expandAll">
                    <template #sub-title>
                        Check out our frequently asked questions that Local Designers like you asked when signing up with Designer Journeys.
                    </template>
                </SectionQuestion>
                <Reviews :listReviews = listReviews class='pt-50 pb-50 mb-pb-10 mb-pt-60'>
                    <template #title>
                        Testimonials
                    </template>
                    <template #sub-title>
                        Don't just take our word for it, see what our network of Local Designers think about working with Designer Journeys!
                    </template>
                </Reviews>
                <ClientOnly>
                <SectionForm id="form" class="bg-form">
                    <template #title>Apply Now</template>
                    <template #form>
                        <form @submit.prevent novalidate autocomplete="off">
                            <div class="flex mb-flex-wrap">
                                <div class="mb-20 pr-20 mb-pr-0 mb-wp-100" v-bind:class="{ errorClass : errors.first_name }">
                                    <label
                                        class="ttu fw-900 fs-11 lh-13 gray-dark mb-8 dib"
                                        for="firstname"
                                    >first name</label
                                    >
                                    <Input
                                        type="text"
                                        placeholder="First Name"
                                        name="firstname"
                                        id="firstname"
                                        autocomplete="given-name"
                                        v-model="form.first_name"
                                    ></Input>
                                    <div class="error-message" v-if="errors.first_name">
                                        {{ errors.first_name.split('_').join(' ') }}
                                    </div>
                                </div>
                                <div class="mb-20 mb-wp-100" v-bind:class="{ errorClass : errors.last_name }">
                                    <label
                                        class="ttu fw-900 fs-11 lh-13 gray-dark mb-8 dib"
                                        for="lastname"
                                    >last name</label
                                    >
                                    <Input
                                        type="text"
                                        placeholder="Last Name"
                                        name="lastname"
                                        id="lastname"
                                        autocomplete="family-name"
                                        v-model="form.last_name"
                                    ></Input>
                                    <div class="error-message" v-if="errors.last_name">
                                        {{ errors.last_name.split('_').join(' ') }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-20" v-bind:class="{ errorClass : errors.work_email }">
                                <label class="ttu fw-900 fs-11 lh-13 gray-dark mb-8 dib" for="email"
                                >work email</label
                                >
                                <Input
                                    type="email"
                                    placeholder="Work Email"
                                    name="email"
                                    id="email"
                                    autocomplete="email"
                                    v-model="form.email"
                                ></Input>
                                <div class="error-message" v-if="errors.work_email">
                                    {{ errors.work_email.split('_').join(' ') }}
                                </div>
                            </div>
                            <div class="mb-20" v-bind:class="{ errorClass : errors.company }">
                                <label class="ttu fw-900 fs-11 lh-13 gray-dark mb-8 dib" for="company"
                                >company</label
                                >
                                <Input
                                    type="text"
                                    placeholder="Company"
                                    name="company"
                                    id="company"
                                    autocomplete="company"
                                    v-model="form.company"
                                ></Input>
                                <div class="error-message" v-if="errors.company">
                                    {{ errors.company }}
                                </div>
                            </div>
                            <div class="mb-20" v-bind:class="{ errorClass : errors.country }">
                                <label class="ttu fw-900 fs-11 lh-13 gray-dark mb-8 dib" for="country"
                                >country</label
                                >
                                <SelectBox
                                    :noPlaceholder="true"
                                    :options="Country"
                                    placeholder="Country"
                                    v-model:optionSelected="form.country"
                                    @update:optionSelected="onChangeNation"
                                ></SelectBox>
                                <div class="error-message" v-if="errors.country">
                                    {{ errors.country }}
                                </div>
                            </div>
                            <div class="mb-20" v-bind:class="{ errorClass : errors.phone }">
                                <label class="ttu fw-900 fs-11 lh-13 gray-dark mb-8 dib">phone</label>
                                <CountrySelect
                                    typeCountry="text"
                                    placeholderCountry="Country"
                                    placeholderPhone="Phone Number"
                                    v-model:country="form.nationality"
                                    v-model:phone="form.phone"
                                    :key="reRenderCountry"
                                    :valueDataCountry="form.nationality"
                                    :showDefault='true'
                                ></CountrySelect>
                                <div class="error-message" v-if="errors.phone">
                                    {{ errors.phone }}
                                </div>
                            </div>
                            <div class="mb-30" v-bind:class="{ errorClass : errors.website }">
                                <label class="ttu fw-900 fs-11 lh-13 gray-dark mb-8 dib" for="website"
                                >website</label
                                >
                                <Input
                                    type="text"
                                    placeholder="Website"
                                    name="website"
                                    id="website"
                                    autocomplete="url"
                                    v-model="form.website"
                                ></Input>
                                <div class="error-message" v-if="errors.website">
                                    {{ errors.website }}
                                </div>
                            </div>
                            <div class="tc mb-20">
                                <ButtonLoading v-if="loading" btnClass='button button-blue wp-100' />
                                <button
                                    v-else
                                    class="button button-blue wp-100"
                                    @click="handleSubmit"
                                >Submit Application</button>
                            </div>
                            <div class="fs-14 lh-18 black"
                            >By continuing you agree to Designer Journeys'
                                <span class="hand underline" @click="toTermOfUse" target="_blank">Terms of Use.</span></div
                            >
                        </form>
                    </template>
                    <template #error>
                        <div
                            id="errorMessages"
                            class="red bg-red-900 tc pt-20 pb-20 pl-30 pr-30 mt-23 wp-100 maxw-550 lh-17"
                            style="margin-left: auto; margin-right: auto;"
                            v-if="messageError"
                            v-html="messageError"
                        >
                        </div>
                    </template>
                </SectionForm>
                </ClientOnly>
            </template>
        </NuxtLayout>
        <AppModal
            :show="showModalSuccess"
            :showFooter="false"
            @closeModal="handleCloseModalSuccess"
        >
            <template #header>
                <div class="flex justify-between items-center">
                    <div class="black fs-16 lh-16 fw-700">Thanks for applying to join Designer Journeys’ network of trusted Local Designers.</div>
                </div>
            </template>
            <template #body>
                <div>One of our dedicated team members is currently reviewing the details you submitted and will be in touch soon to continue your application to become a Local Designer.</div>
            </template>
        </AppModal>
    </div>
</template>

<script>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import SectionHero from '~/components/sections/SectionHero/SectionHero'
import SectionQuestion from '~/components/sections/SectionQuestion/SectionQuestion'
import Reviews from '~/components/sections/SectionReview/Reviews'
import SectionForm from '~/components/pages/User/sections/SectionForm/SectionForm'
import Input from '~/components/ui/input/Input'
import SelectBox from '~/components/ui/selectbox/SelectBox'
import CountrySelect from '~/components/ui/country-selectbox/CountrySelect'
import countryList from '~/components/ui/country-selectbox/country.json'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import { computed, onMounted, reactive, ref, watchEffect } from 'vue'
import { load } from 'recaptcha-v3'
import parsePhoneNumber from 'libphonenumber-js'
import authApi from '~/composables/api/authApi'
import useFormValidation from '~/utils/validators'
import AppModal from '~/components/ui/modal/AppModal'
import ButtonLoading from '~/components/ui/loading-button/ButtonLoading'
import { getCountryPhone } from '~/helper'
import { getCookie } from '~/mixins/cookie'
import Metadata from '~/assets/meta_data.json'
import { useGetCookie } from '~/composables/common/useCustomCookie'

export default {
    name: 'become-local-designer',
    components: {
        SectionHero,
        SectionQuestion,
        Reviews,
        SectionForm,
        Input,
        SelectBox,
        CountrySelect,
        AppModal,
        ButtonLoading
    },
    setup() {
        const router = useRouter()
        const Country = ref(countryList)
        const loading = ref(false)
        // const disabled = ref(true)
        const messageError = ref('')
        const showModalSuccess = ref(false)
        const reRenderCountry = ref(0)
        const route = useRoute()
        const runtime = useRuntimeConfig()
        const country_code = useGetCookie('country_code')
        const country_name = useGetCookie('country_name')
        const expandAll = ref(true)
        const handleCloseModalSuccess = (val) =>{
            showModalSuccess.value = val
        }

        const listReviews = [
            {
                avatar: 'https://s3-cdn.designerjourneys.com/static/images/user/local-designer/staffan2.jpg',
                content:
                    'Great staff who are super helpful in facilitating communication with our clients. An easy-to-use platform that helps us create stunning tours. Great reach in markets that are important to us.',
                author: 'Staffan'
            },
            {
                avatar: 'https://s3-cdn.designerjourneys.com/static/images/user/local-designer/michael-lynden-bell.jpg',
                content:
                    'Working with Designer Journeys has been a rewarding experience, we have created some amazing trips for their clients. There’s no limit to how creative we can be, we have explored new places, uncovered hidden gems, and sent clients on holidays that will leave lifelong memories. Every request is unique and different which adds to the challenge of creating a fully-customised holiday. ',
                author: 'Michael'
            },
            {
                avatar: 'https://s3-cdn.designerjourneys.com/static/images/user/local-designer/moreno.jpg',
                content:
                    'I love working with Designer Journeys because it gives us the chance to organise incredible new trips to explore more off-the-beaten-path parts of Italy and mix them with classical destinations. I love being part of this great family community.',
                author: 'Moreno'
            },
            {
                avatar: 'https://s3-cdn.designerjourneys.com/static/images/user/local-designer/amandine.jpg',
                content:
                    'As a Local Designer, it is not always easy to find new potential travellers, but by joining Designer Journeys we were able to reach a whole new clientele. The flexibility of the platform allows us to completely tailor-make our tours to showcase the best of Japan and 100% match travellers\' needs. Communication with the team is always easy, fast and efficient. The back office allows us to create great and functional itineraries for our clients very quickly. ',
                author: 'Amandine'
            },
            {
                avatar: 'https://s3-cdn.designerjourneys.com/static/images/user/local-designer/hai.jpg',
                content:
                    "Designer Journeys is a great marketplace to work with. They have a very friendly system to build trip plans and supportive staff. Designer Journeys provides excellent information about travellers' expectations and ideas so Local Designers like me can organise the best matching trips.",
                author: 'Hai'
            },
            {
                avatar: 'https://s3-cdn.designerjourneys.com/static/images/user/local-designer/quynh.jpg',
                content:
                    'We love working with the Designer Journeys team. They are very flexible and always go the extra mile to offer the best products and services. They care about our travellers like family members. We can’t wait to deliver fun and exciting experiences for our clients!',
                author: 'Quynh'
            }
        ]

        const faqs = ref([
            {
                id: 1,
                title: 'Who is Designer Journeys?',
                text: 'Designer Journeys’ delivers unique travel experiences through its global network of Local Designers who are deeply knowledgeable travel experts that design, build and deliver extraordinary travel experiences. Designer Journeys has Local Designers in over 70 countries around the world and specialises in custom travel for individuals and groups looking for premium, unique, hard-to-find travel experiences. Established in 2017, the company operated as Tripfuser until August 2021 when it underwent a rebrand to Designer Journeys to better convey the premium nature and uniqueness of the service offered to Travel Agents and Travellers.',
            },
            {
                id: 2,
                title: 'What Benefits Does Designer Journeys Offer Local Designers?',
                text: '<ul class="list-ans"><li class="lh-24">B2B and B2C Market Access - you’ll have access to high-converting leads from our Traveller and Travel Agent markets.</li><li class="lh-24">Local Designer of the Month Scheme - your efforts will be rewarded through additional marketing of your trips.</li><li class="lh-24">Easy-to-Use Platform for Lead Management - you’ll be able to easily manage your enquiries and ongoing conversations through our online system. </li><li class="lh-24">Full Training and Sales Support from Network Team - full onboarding will be provided as well as continued system and sales support.</li><li class="lh-24">Digital Itineraries Built by Content Team - save yourself time and let our Content Team build your itineraries on our platform so that they are digital, easily customisable and shareable.</li><li class="lh-24">Flexible Cancellation Requirements and Payment Solutions Access - we work with you to find the best solution.</li></ul>',
            },
            {
                id: 3,
                title: 'What Does the Application Process Involve to Become a Local Designer?',
                text: 'To become a Designer Journeys Local Designer, applicants complete a rigorous selection ' +
                    'process to ensure they are reliable, vetted, trustworthy and able to deliver quality travel ' +
                    'experiences every time. Once they have provided strong evidence of positive traveller feedback, ' +
                    'local accreditations, and necessary licenses, and have signed our marketplace ' +
                    '<a href="/terms-of-use"><span class="black underline">Terms of Use</span></a>' +
                    ' they are eligible to become a Designer Journeys Local Designer.',
            },
        ])
        const goto = () => {
            let element = document.getElementById("form");
            element.scrollIntoView({behavior: "smooth"});
        }

        const toTermOfUse = () => {
            // router.push({ path: '/terms-of-use' })
            let routerLink = router.resolve({name: 'terms-trip-plan-builder'});
            window.open(routerLink.href, '_blank');
        }

        // const recaptchaKey = ref('')
        // const onLoadRecaptcha = async () => {
        //   disabled.value = false
        //   messageError.value = ''
        //   /* Load recaptcha */
        //   const recaptcha = await load(`${process.env.VUE_APP_SITE_KEY_GRECAPTCHA}`)
        //   const token = await recaptcha.execute('register')
        //   recaptchaKey.value = token
        // }
        //
        onMounted(() => {
          debounceAmplitudeScriptTracking("View Become a Local Designer")
          //onLoadRecaptcha()
        })

        onBeforeRouteLeave(async () => {
            errors.first_name = ''
            errors.last_name = ''
            errors.country = ''
            errors.company = ''
            errors.work_email = ''
            errors.phone = ''
            errors.website = ''
            // disabled.value = true
        })

        const form = reactive({
            first_name: '',
            last_name: '',
            email: '',
            company: '',
            nationality: country_code.value || 'VN',
            country: {
                code: country_code.value || 'VN',
                name: country_name.value || 'Vietnam'
            },
            phone: '',
            website: ''
        })

        /* detect country code while API called completed for first time */
        if (!form.nationality) {
            let timesRun = new Date().getTime();
            form.nationality = country_code.value

            let interval = setInterval(() => {
                if (country_code.value) {
                    clearInterval(interval)
                }
                if (form.nationality !== country_code.value) {
                    form.nationality = country_code.value
                    form.country = {
                        code: country_code.value,
                        name: country_name.value
                    }
                }
                if(new Date().getTime() - timesRun > 15000){
                    clearInterval(interval);
                }
            }, 500)
        }

        const onChangeNation = () => {
            // form.nationality = value.code
            reRenderCountry.value += 1
        }

        /* Watch format number phone */
        watchEffect(()=>{
            let phoneNumber = parsePhoneNumber(form.phone, form.nationality)
            if (phoneNumber) {
                form.phone = phoneNumber.nationalNumber
            }
        })

        const {
            validateNameField,
            validateEmailField,
            validatePhoneNumberField,
            errors,
        } = useFormValidation()

        const handleSubmit = async() =>{
            validateNameField('first_name', form.first_name)
            validateNameField('last_name', form.last_name)
            validateNameField('country', form.country.code)
            validateNameField('company', form.company)
            validateEmailField('work_email', form.email, 'auth')
            validatePhoneNumberField('phone', form.phone, form.nationality)
            validateNameField('website', form.website)
            if (
                !errors.first_name &&
                !errors.last_name &&
                !errors.nationality &&
                !errors.company &&
                !errors.work_email &&
                !errors.phone &&
                !errors.country &&
                !errors.website
            ) {
                loading.value = true
                messageError.value = ''
                try {
                    let country_code = form.nationality || getCookie("country_code=")
                    let dial_phone = getCountryPhone(country_code)

                    const recaptcha = await load(`${useAppConfig().siteKeyGreCaptcha}`)
                    const token = await recaptcha.execute('register')

                    const res = await authApi.signUpLocalDesigner({
                        first_name: form.first_name,
                        last_name: form.last_name,
                        email: form.email,
                        company: form.company,
                        nationality: form.country.code,
                        nationality_name: form.country.name,
                        phone: dial_phone.concat(form.phone),
                        website: form.website,
                        'g-recaptcha-response': token
                    })
                    if(res.data.error === 0){
                        loading.value = false
                        showModalSuccess.value = true
                        resetForm()
                    } else{
                        messageError.value = res.data.message
                        loading.value = false
                    }
                    loading.value = false
                } catch (err) {
                    console.log(err)
                }
            }
        }

        const resetForm = () =>{
            form.first_name = ''
            form.last_name = ''
            form.email = ''
            form.company = ''
            form.nationality = ''
            form.country.code = 'VN'
            form.country.name = 'Vietnam'
            form.phone = ''
            form.website = ''
        }

        const metaData = ref(Metadata);
        // useHead({
        //     title: computed(() => {
        //         const title = metaData.value.become_a_local_designer.title
        //         return title
        //     }),

        //     meta: computed(() => {
        //         const title = metaData.value.become_a_local_designer.title
        //         const description = metaData.value.become_a_local_designer.description
        //         return [
        //             {
        //                 name: `title`,
        //                 content: title,
        //             },
        //             {
        //                 name: `description`,
        //                 content: description,
        //             }
        //         ]
        //     }),
        //     link: computed(() => {
        //         return [
        //             { rel: 'canonical', href: `${runtime.public.publicDomain}${route.fullPath}`, hreflang: 'en'}
        //         ]
        //     }),
        // })

        onMounted(()=> expandAll.value = false)

        return {
            Country,
            goto,
            toTermOfUse,
            form,
            /*disabled,*/
            messageError,
            listReviews,
            handleSubmit,
            errors,
            loading,
            showModalSuccess,
            handleCloseModalSuccess,
            onChangeNation,
            reRenderCountry,
            faqs,
            expandAll
        }
    },
}
</script>
<style lang="scss" scoped>
.bg-hero {
    background: url('https://s3-cdn.designerjourneys.com/static/images/user/local-designer/bg-localdesigner.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    height: 340px;
}
.requirement {
    background: rgba(241, 241, 241, 0.5);
    padding: 100px 110px 110px 110px;
    min-height: 640px;
    height: 100%;
    position: relative;
}
.custom-img {
    top: -200px;
}
.benefit {
    background: rgba(164, 203, 250, 0.15);
    position: relative;
    padding: 200px 110px 110px 110px;
    top: -100px;
    z-index: -1;
    min-height: 582px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.bg-form {
    background: url('https://s3-cdn.designerjourneys.com/static/images/user/local-designer/bg-form.jpg');
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;
}
@include desktop{
    .requirement {
        padding: 60px 20px;
        height: auto;
    }
    .benefit {
        padding: 60px 20px;
        position: relative;
        top: auto;
        height: auto;
    }

}
@include phone{
    .sp-none {
        display: none;
    }
    .custom-img {
        top: 0px;
    }
    .benefit-item img {
        width: 30px;
        height: auto;
    }
}
</style>
